import React, { Component } from "react";
import { MDBRow, MDBCol, MDBContainer, MDBCard, MDBCardBody, MDBCardTitle, MDBCardText } from "mdbreact";
import { admission } from "../../config/api";

import axios from "axios";
import PresentLayout from "./PresentLayout";

export default class Insertpresent6 extends Component {

    constructor(props) {
        super(props)
        this.state = {
            REGISTER_ID: null,
            FUND_STATUS_ID: "0",
            FUND_STATUS_DETAIL: null,
            TALENT: null,
            SON_NUM: null,
            SON_STDNUM: null,
            array_talent: [
                { TALENT_ID: "01", TALENT_NAME: "ด้านภาษาต่างประเทศ" },
                { TALENT_ID: "02", TALENT_NAME: "ด้านคอมพิวเตอร์" },
                { TALENT_ID: "03", TALENT_NAME: "ด้านกิจกรรมสันทนาการ" },
                { TALENT_ID: "04", TALENT_NAME: "ด้านศิลปะ" },
                { TALENT_ID: "05", TALENT_NAME: "ด้านกีฬา" },
                { TALENT_ID: "06", TALENT_NAME: "ด้านนาฏศิลป/ดนตรีขับร้อง" },
                { TALENT_ID: "00", TALENT_NAME: "อื่นๆ" },
            ]
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        axios.get(admission + "/student/loadpresent/" + localStorage.getItem("ID_LOGIN")).then((respone) => {
            respone.data = respone.data.filter(({ REGISTER_STATUS }) => !(REGISTER_STATUS === "11"));
            this.setState({ REGISTER_ID: respone.data[0]["REGISTER_ID"] });
            // axios.get(admission + "/student_insertpresent6/profilework/"+respone.data[0]["REGISTER_ID"]).then((data) => {
            axios.get(admission + "/student_insertpresent6/profilework/" + respone.data[0]["REGISTER_ID"]).then((data) => {
                if (data.data.length !== 0) {
                    if (data.data[0]["FUND_STATUS_ID"] !== "0" && data.data[0]["FUND_STATUS_ID"] !== "3") {
                        this.setState({ FUND_STATUS_ID: data.data[0]["FUND_STATUS_ID"] });
                        this.setState({ FUND_STATUS_DETAIL: data.data[0]["FUND_STATUS_DETAIL"] });
                    } else {
                        this.setState({ FUND_STATUS_ID: data.data[0]["FUND_STATUS_ID"] });
                    }
                    this.setState({ TALENT: data.data[0]["TALENT"] });
                    this.setState({ SON_NUM: data.data[0]["SON_NUM"] });
                    this.setState({ SON_STDNUM: data.data[0]["SON_STDNUM"] });
                }
            })
        })
    }

    handleChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleClick(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleSubmit(event) {
        event.preventDefault();
        let bodydata = {
            REGISTER_ID: this.state.REGISTER_ID,
            FUND_STATUS_ID: this.state.FUND_STATUS_ID,
            FUND_STATUS_DETAIL: this.state.FUND_STATUS_DETAIL,
            TALENT: this.state.TALENT,
            SON_NUM: this.state.SON_NUM,
            SON_STDNUM: this.state.SON_STDNUM
        }
        console.log(bodydata);
        // axios.post(admission + "/student_insertpresent6/updatepresent/"+this.state.REGISTER_ID, bodydata).then((data) => {
        axios.post(admission + "/student_insertpresent6/updatepresent/" + this.state.REGISTER_ID, bodydata).then((data) => {
            window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Insertpresent7`;
        })
    }

    render() {
        return (
      <>
        <PresentLayout
          step={6}
          title="ข้อมูลความสามารถพิเศษ"
          metaTitle="ข้อมูลความสามารถพิเศษ มหาวิทยาลัยราชภัฏกำแพงเพชร"
        >
          <MDBContainer fluid>
                <form onSubmit={this.handleSubmit}>

                    <MDBRow>
                        <MDBCol lg="1" md="0" sm="0"></MDBCol>
                        <MDBCol lg="10" md="12" sm="12">
                            <MDBCard>
                                <MDBCardBody>
                                    <MDBContainer fluid>
                                        <MDBRow>
                                            <MDBCol>
                                                <MDBCardTitle>
                                                    ข้อมูลความสามารถพิเศษ
                                                </MDBCardTitle>
                                                <MDBCardText>
                                                    <span className="text-danger">* จำเป็นต้องกรอกข้อมูล</span>
                                                    <MDBRow className="mt-2">
                                                        <MDBCol lg="4" md="12" sm="12">
                                                            <div className="form-outline mt-2">
                                                                <label className="form-label" for="FUND_STATUS_ID2">สถานะการได้รับทุน <span className="text-danger">*</span></label><br />
                                                                <div className="form-check">
                                                                    <input className="form-check-input" type="radio" name="FUND_STATUS_ID" id="FUND_STATUS_ID1" onClick={this.handleClick} value="0" checked={this.state.FUND_STATUS_ID === "0" ? true : false} />
                                                                    <label className="form-check-label" for="FUND_STATUS_ID1">ไม่ได้รับทุนการศึกษา</label>
                                                                </div>
                                                                <div className="form-check">
                                                                    <input className="form-check-input" type="radio" name="FUND_STATUS_ID" id="FUND_STATUS_ID2" onClick={this.handleClick} value="1" checked={this.state.FUND_STATUS_ID === "1" ? true : false} />
                                                                    <label className="form-check-label" for="FUND_STATUS_ID2">ได้รับทุนการศึกษาต้องชดใช้(ทุนรัฐบาล (สำนักงาน กพ.), ทุนมหาวิทยาลัย)</label>
                                                                </div>
                                                                <div className="form-check">
                                                                    <input className="form-check-input" type="radio" name="FUND_STATUS_ID" id="FUND_STATUS_ID3" onClick={this.handleClick} value="2" checked={this.state.FUND_STATUS_ID === "2" ? true : false} />
                                                                    <label className="form-check-label" for="FUND_STATUS_ID3">ได้รับทุนการศึกษาให้เปล่า(ทุนมูลนิธิจรูญเอื้อชูเกียรติ, กองทุนการศึกษาเอสโซ่)</label>
                                                                </div>
                                                                <div className="form-check">
                                                                    <input className="form-check-input" type="radio" name="FUND_STATUS_ID" id="FUND_STATUS_ID4" onClick={this.handleClick} value="3" checked={this.state.FUND_STATUS_ID === "3" ? true : false} />
                                                                    <label className="form-check-label" for="FUND_STATUS_ID4">ได้รับทุน กยศ.หรือกรอ.</label>
                                                                </div>
                                                            </div>
                                                        </MDBCol>
                                                        {this.state.FUND_STATUS_ID === "1" || this.state.FUND_STATUS_ID === "2" ? <>
                                                            <MDBCol lg="8" md="12" sm="12">
                                                                <div className="form-outline mt-2">
                                                                    <label className="form-label" for="FUND_STATUS_DETAIL">ชื่อทุนการศึกษาที่ได้รับ <span className="text-danger">*</span></label>
                                                                    <input type="text" className="form-control" id="FUND_STATUS_DETAIL" name="FUND_STATUS_DETAIL" value={this.state.FUND_STATUS_DETAIL} onChange={this.handleChange} required />
                                                                </div>
                                                            </MDBCol>
                                                        </> : <></>}
                                                    </MDBRow>

                                                    <MDBRow className="mt-2">
                                                        <MDBCol lg="4" md="4" sm="12">
                                                            <div className="form-outline mt-2">
                                                                <label className="form-label" for="TALENT">ความถนัดความสนใจพิเศษ <span className="text-danger">*</span></label>
                                                                {/* <input type="text" className="form-control" id="TALENT" name="TALENT" value={this.state.TALENT} onChange={this.handleChange} required /> */}
                                                                <select className="form-control" id="TALENT" name="TALENT" onChange={this.handleChange} required>
                                                                    <option value="" hidden>ระบุความถนัดความสนใจพิเศษ</option>
                                                                    {this.state.array_talent.map((data) => {
                                                                        return data.TALENT_ID === this.state.TALENT ? <>
                                                                            <option value={data.TALENT_ID} selected>{data.TALENT_NAME}</option>
                                                                        </> : <>
                                                                            <option value={data.TALENT_ID}>{data.TALENT_NAME}</option>
                                                                        </>
                                                                    })}
                                                                </select>
                                                            </div>
                                                        </MDBCol>
                                                        <MDBCol lg="4" md="4" sm="12">
                                                            <div className="form-outline mt-2">
                                                                <label className="form-label" for="SON_NUM">จำนวนพี่น้องทั้งหมด <span className="text-danger">*</span></label>
                                                                <input type="text" className="form-control" id="SON_NUM" name="SON_NUM" value={this.state.SON_NUM} onChange={this.handleChange} required />
                                                            </div>
                                                        </MDBCol>
                                                        <MDBCol lg="4" md="4" sm="12">
                                                            <div className="form-outline mt-2">
                                                                <label className="form-label" for="SON_STDNUM">จำนวนพี่น้องที่กำลังศึกษาอยู่ <span className="text-danger">*</span></label>
                                                                <input type="text" className="form-control" id="SON_STDNUM" name="SON_STDNUM" value={this.state.SON_STDNUM} onChange={this.handleChange} required />
                                                            </div>
                                                        </MDBCol>
                                                    </MDBRow>
                                                </MDBCardText>
                                            </MDBCol>
                                        </MDBRow>
                                        {(this.state.FUND_STATUS_ID === "0" || this.state.FUND_STATUS_ID === "3") && this.state.TALENT && this.state.SON_NUM && this.state.SON_STDNUM ? <>
                                            <button type="submit" className="btn btn-primary btn-rounded btn-md mt-2">บันทึกข้อมูล</button>
                                        </> : <>
                                            {(this.state.FUND_STATUS_ID === "1" || this.state.FUND_STATUS_ID === "2") && this.state.FUND_STATUS_DETAIL && this.state.TALENT && this.state.SON_NUM && this.state.SON_STDNUM ? <>
                                                <button type="submit" className="btn btn-primary btn-rounded btn-md mt-2">บันทึกข้อมูล</button>
                                            </> : <>
                                                <button type="submit" className="btn btn-primary btn-rounded btn-md mt-2" disabled>บันทึกข้อมูล</button>
                                            </>}
                                        </>}
                                    </MDBContainer>
                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>
                        <MDBCol lg="1" md="0" sm="0"></MDBCol>
                    </MDBRow>
                </form>
            </MDBContainer>
                </PresentLayout>
      </>)
    }
}

